module.exports = __webpack_public_path__ + "032454ab25b661155db0eade3f69a799.gif";